import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Upload,
  Card,
  message,
  Layout,
  Image,
  Divider,
  Space,
  Menu,
  Radio,
  Checkbox,
} from "antd";
import {
  UploadOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import Sider from "antd/es/layout/Sider";
import { Header } from "antd/es/layout/layout";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import "./UserRules.css"
const { TextArea } = Input;
const { Content } = Layout;

const UserRules = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} isMobile={isMobile} role="user" />
      <Layout
        style={{
          marginLeft: isMobile ? "0px" : collapsed ? "80px" : "200px",
          transition: "0.3s ease",
          width: "100%",
        }}
      >
        <Header
          className="MainHeader"
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => {
              if (isMobile) {
                setMobileOpen(true);
              } else {
                setCollapsed(!collapsed);
              }
            }}
            style={{ fontSize: 18, width: 64, height: 64 }}
          />
          <h2 style={{ margin: 0 }}>Users Rules & Regulations</h2>
        </Header>

        <div className="guidelines-page">
          {/* HERO */}
          <div className="guidelines-hero">
            <h1>Guidelines for Uploading Yoga Images</h1>
            <p>
              Help us build the world’s most trusted yoga reference library 🌍
            </p>
          </div>

          <div className="guidelines-container">
            <section className="guideline-section">
              <h2>📋 Basic Eligibility & Rights</h2>

              <div className="rule-card success">
                <h4>✅ Only Your Own Photos</h4>
                <ul>
                  <li>Photos taken by you</li>
                  <li>Written permission required if not</li>
                  <li>AI-generated images are not allowed</li>
                </ul>
              </div>

              <div className="rule-card warning">
                <h4>👶 Permission from Others</h4>
                <ul>
                  <li>Consent required for anyone in the image</li>
                  <li>Children require parent/guardian approval</li>
                </ul>
              </div>

              <div className="rule-card info">
                <h4>📜 Licensing Agreement</h4>
                <ul>
                  <li>10 years display rights for Yogarefer.com</li>
                  <li>Resize allowed if required</li>
                  <li>Your creator rights remain with you</li>
                </ul>
              </div>
            </section>

            {/* IMAGE QUALITY */}
            <section className="guideline-section">
              <h2>🖼️ Image Quality Rules</h2>

              <div className="two-column">
                <div className="rule-card success">
                  <h4>📸 Shooting Method</h4>
                  <ul>
                    <li>Yoga mat only</li>
                    <li>Natural daylight</li>
                    <li>Clear & steady shots</li>
                    <li>Yoga-appropriate clothing</li>
                  </ul>
                </div>

                <div className="rule-card danger">
                  <h4>🚫 Things to Avoid</h4>
                  <ul>
                    <li>Watermarks / logos</li>
                    <li>AI filters or face changers</li>
                    <li>Dangerous locations</li>
                    <li>Over-saturated colors</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* TECHNICAL DETAILS */}
            <section className="guideline-section">
              <h2>📱 Technical Details</h2>

              <table className="guidelines-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Requirement</th>
                    <th>Tip</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>File Size</td>
                    <td>Up to 3MB</td>
                    <td>Mobile photos are enough</td>
                  </tr>
                  <tr>
                    <td>Format</td>
                    <td>.jpg, .png, .webp</td>
                    <td>.jpg recommended</td>
                  </tr>
                  <tr>
                    <td>Resolution</td>
                    <td>HD (1920×1080)</td>
                    <td>Book-quality clarity</td>
                  </tr>
                </tbody>
              </table>
            </section>

            {/* UPLOAD PROCESS */}
            <section className="guideline-section">
              <h2>📤 Upload Process</h2>

              <ol className="steps">
                <li>Go to upload page</li>
                <li>Select photo (≤ 3MB)</li>
                <li>Fill pose & creator details</li>
                <li>Submit for review</li>
              </ol>

              <div className="rule-card info">
                <strong>⏱ Review Time:</strong> 24–48 hours (weekends may vary)
              </div>
            </section>

            {/* VIOLATIONS */}
            <section className="guideline-section">
              <details className="accordion">
                <summary>⚖️ Rule Violations & Penalties</summary>
                <ul>
                  <li>1st: Warning + removal</li>
                  <li>2nd: 7-day upload block</li>
                  <li>3rd: 30-day account block</li>
                  <li>4th: Permanent ban</li>
                </ul>
              </details>
            </section>

            {/* CHECKLIST */}
            {/* <section className="guideline-section">
              <h2>✅ Final Acknowledgement</h2>

              <div className="final-checklist">
                <label>
                  <input
                    type="checkbox"
                    onChange={(e) => setAgreed(e.target.checked)}
                  />
                  I confirm that I have read and understood all rules
                </label>
              </div>

              <button className="primary-btn" disabled={!agreed}>
                Proceed to Upload
              </button>
            </section> */}
          </div>
        </div>
      </Layout>
    </Layout>
  );
};

export default UserRules;
